import React, { useEffect } from 'react';
import classNames from 'classnames';
import loadScript from 'lib/loadScript';
import htmlSetIframeLoadingAttributes from 'lib/htmlSetIframeLoadingAttributes';

/**
 * InstagramEmbed component renders an Instagram post embed.
 *
 * @param {object} props - The component props.
 * @param {string} [props.html=null] - The HTML content for the embed.
 * @param {string} [props.className=''] - Additional CSS classes for the wrapper.
 * @param {object} props.widget - Widget configuration object.
 * @returns {JSX.Element} The rendered Instagram embed.
 */
export const InstagramEmbed = ({ html = null, className = '', widget }) => {
  useEffect(() => {
    loadScript('//www.instagram.com/embed.js')
      .then(() => window.instgrm?.Embeds?.process());
  }, []);

  const innerHTML = htmlSetIframeLoadingAttributes((html || widget.baseline).trim(), 'lazy');
  const wrapperClass = classNames(className, 'embed-widget__use-presentation');

  // Replace iframe embed with blockquote markup
  if (/^<iframe/.test(innerHTML)) {
    const embedId = `https://www.instagram.com/p/${widget.properties['instagram-id']}`;
    return (
      <div className={wrapperClass}>
        <blockquote
          className="instagram-media embed-widget__blockquote"
          data-instgrm-captioned
          data-instgrm-permalink={embedId}
          data-instgrm-version="8"
        >
          <div className="embed-widget__outer">
            <div className="embed-widget__inner">
              <div className="embed-widget__profile" />
            </div>
            <p className="embed-widget__paragraph">
              <a href={embedId}>{embedId}</a>
            </p>
          </div>
        </blockquote>
      </div>
    );
  }

  // eslint-disable-next-line react/no-danger
  return <div className={wrapperClass} dangerouslySetInnerHTML={{ __html: innerHTML }} />;
};


